import { secondsToHm } from './date';
import { showToastSuccess } from './toast';

export const copyToClipboard = (url) => {
    const el = document.createElement('textarea');
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};
export const copyStatusReport = (data = []) => {
    const values = data.map(e => ` - ${e?.task?.link || e?.task?.name} - ${e?.activityType?.name || ''} - ${secondsToHm(e?.duration, true)}<br/>`).join('');
    const formatID = document.getElementById("u_copy-text") || document.getElementById("u_status-report");
    if (formatID) formatID.innerHTML = values;
    copyToClipboard(formatID?.innerText);
    showToastSuccess('Status Report Copied Successfully!');
};
export const copyTicketLink = (ticketId) => {
    const ticketURL = ticketId ? `${window.location.href}/${ticketId}` : window.location.href;
    navigator.clipboard.writeText(ticketURL);
    showToastSuccess('Ticket link copied to clipboard.');
};

export const copyTaskLink = (link) => {
    navigator.clipboard.writeText(link);
    showToastSuccess("Link copied to clipboard.")
};

export const copyLink = (link, text) => {
    if (navigator.clipboard) navigator.clipboard.writeText(link)
    showToastSuccess(text ? `${text} link copied to clipboard.` : "Link copied to clipboard.");
};

// ===== migrated from pms/src/common/functions/common.jsx =====
export const copyProjectLink = () => {
    let taskURL = window.location.href;
    navigator.clipboard.writeText(taskURL)
    showToastSuccess('The project link was copied to your clipboard.')
};

export const copyMultipleTaskLink = (data = [], flag = false) => {
    let formatID = document.getElementById("u_copy-task-link");
    let values = '';
    const url = window?.location?.href?.split('/')
    if (flag) url?.pop();

    data.forEach(e => {
        values = `${values} - ${e?.taskNumberStr} - ${url?.join('/')}/${e?.taskId}<br/>`;
    })
    if (formatID) formatID.innerHTML = values

    copyToClipboard(formatID?.innerText)
    showToastSuccess('Tasks Copied Successfully!')
}
